export default __webpack_public_path__ + "static/media/check-blue.5ff85e10.svg";